class TCodeFunScript {
  constructor() {
    this.name = '';
    this.range = 0;
    this.mb = '';
    this.data = [];
    this.actions = [];
  }

  sort() {
    if (!this.actions || this.actions.length === 0) {
      return;
    }
    this.actions.sort((a, b) => a.at - b.at);
  }
}

TCodeFunScript.Action = class {
  constructor(at, pos) {
    this.at = at || 0;
    this.pos = pos || 0;
    this.cmd = '';
  }

  setCmd(cmd, limit = 0) {
    if (limit > 0) {
      this.cmd = cmd + "I" + limit;
    } else {
      this.cmd = cmd;
    }
  }
};

class TCodeFunScriptPlayer {
  //static HOME = "L05050S1000 L15050S1000 L25050S1000 R05050S1000 R15050S1000 R25050S1000 V00000S1000 V10000S1000 V20000S1000 V30000S1000 A05050S1000 A15050S1000 A20000S1000 A35050S1000";
  static RUN_STATE_STOP = 1;
  static RUN_STATE_RUN = 2;

  constructor() {
    this.scripts = [];
    this.cmdTempList = [];
    this.runState = TCodeFunScriptPlayer.RUN_STATE_STOP;
    this.executor = null;
    this.sendCommandCallback = null; // Callback for sending commands
  }

  static getInstance() {
    if (!TCodeFunScriptPlayer.singleton) {
      TCodeFunScriptPlayer.singleton = new TCodeFunScriptPlayer();
    }
    return TCodeFunScriptPlayer.singleton;
  }

  isRunning() {
    return this.runState === TCodeFunScriptPlayer.RUN_STATE_RUN;
  }

  getRunState() {
    return this.runState;
  }

  // Set the callback function for sending commands
  setSendCommandCallback(callback) {
    if (typeof callback === 'function') {
      this.sendCommandCallback = callback;
    } else {
      console.error('Invalid callback provided. Must be a function.');
    }
  }

  addScript(mapJSON, maxChange = 1, limit = 0) {
    this.scripts = [];
    this.cmdTempList = [];

    if (!mapJSON || Object.keys(mapJSON).length <= 0) {
      return;
    }
    // 如果传入的是Map，先转换为普通对象
    const scriptData = mapJSON instanceof Map ? Object.fromEntries(mapJSON) : mapJSON;

    if (!scriptData || Object.keys(scriptData).length <= 0) {
      return;
    }
    // 1. Set up scripts
    for (const [name, json] of Object.entries(scriptData)) {
      // 这里json已经是解析好的对象，不需要再parse
      const funScriptBean = json;
      const script = new TCodeFunScript();
      script.name = name;
      script.range = funScriptBean.range || 100;
      // if(funScriptBean.mb == 'V1'){
      //   funScriptBean.actions = funScriptBean.data;
      // }
      script.actions = (funScriptBean.actions || []).map(a => {
        const action = new TCodeFunScript.Action(a.at, a.pos);
        return action;
      });

      if (!script.actions || script.actions.length <= 0) {
        continue;
      }

      for (let i = 0; i < script.actions.length - 1; i++) {
        const current = script.actions[i];
        const next = script.actions[i + 1];

        current.setCmd(this.getCommand(name, current.pos, script.range), limit);
        next.setCmd(this.getCommand(name, next.pos, script.range), limit);

        this.cmdTempList.push(current);

        const timeDiff = next.at - current.at;
        const posDiff = next.pos - current.pos;
        let steps = Math.abs(posDiff) / maxChange;
        if (steps === 0) {
          steps = 1;
        }
        const timeStep = timeDiff / steps;
        const posStep = posDiff / steps;

        for (let j = 1; j < steps; j++) {
          const newAt = current.at + j * timeStep;
          const newPos = current.pos + j * posStep;
          const newAction = new TCodeFunScript.Action(newAt, newPos);
          newAction.setCmd(this.getCommand(name, newPos, script.range), limit);
          this.cmdTempList.push(newAction);
        }
      }

      const last = script.actions[script.actions.length - 1];
      last.setCmd(this.getCommand(name, last.pos, script.range), limit);
      this.cmdTempList.push(last);

      this.scripts.push(script);
    }

    // 2. Sort commands
    this.cmdTempList.sort((a, b) => a.at - b.at);

    // 3. Merge commands (within 5ms)
    const tempList = [];
    let lastCmd = null;

    for (let i = 0; i < this.cmdTempList.length; i++) {
      const cmd = this.cmdTempList[i];
      if (i === 0) {
        lastCmd = cmd;
        tempList.push(cmd);
        continue;
      }
      if (cmd.at - lastCmd.at < 2) {
        lastCmd.cmd = lastCmd.cmd + " " + cmd.cmd;
      } else {
        lastCmd = cmd;
        tempList.push(cmd);
      }
    }

    this.cmdTempList = tempList;
  }

  // async loadScript(filePath, maxChange = 1, limit = 0) {
  //   // In a browser environment, you would typically use fetch API
  //   // For Node.js, you would use fs module
  //   // This is a placeholder implementation
  //   console.warn("loadScript not fully implemented - needs file system access");
  //
  //   // Mock implementation that assumes mapJSON is available
  //   // In a real implementation, you would read files from the filePath
  //   const mapJ = {};
  //   // ... populate mapJ by reading files ...
  //   this.addScript(mapJ, maxChange, limit);
  // }

  stop() {
    this.runState = TCodeFunScriptPlayer.RUN_STATE_STOP;
    if (this.executor) {
      clearTimeout(this.executor);
      this.executor = null;
    }
    console.log("==停止===");
  }

  runScript(beginTime = 0, isLoop = false) {
    if (!this.cmdTempList || this.cmdTempList.length <= 0) {
      this.runState = TCodeFunScriptPlayer.RUN_STATE_STOP;
      return;
    }
    if (!this.sendCommandCallback) {
      console.error('No send command callback set. Use setSendCommandCallback() first.');
      return;
    }

    this.runState = TCodeFunScriptPlayer.RUN_STATE_RUN;
    let index = 0;

    if (beginTime > 0) {
      for (let i = 0; i < this.cmdTempList.length; i++) {
        if (this.runState === TCodeFunScriptPlayer.RUN_STATE_STOP) {
          return;
        }
        const cmdBean = this.cmdTempList[i];
        if (cmdBean.at >= beginTime) {
          index = i;
          break;
        }
      }
    }

    let start = Date.now();
    let i = index;

    const executeCommands = () => {
      if (this.runState === TCodeFunScriptPlayer.RUN_STATE_STOP || i >= this.cmdTempList.length) {
        if (isLoop && this.runState !== TCodeFunScriptPlayer.RUN_STATE_STOP) {
          // Loop back to beginning
          i = 0;
          start = Date.now();
          this.executor = setTimeout(executeCommands, 0);
        } else {
          this.runState = TCodeFunScriptPlayer.RUN_STATE_STOP;
        }
        return;
      }

      const cmdBean = this.cmdTempList[i];
      const now = Date.now() - start + beginTime;
      const delay = cmdBean.at - now;

      if (delay > 0) {
        this.executor = setTimeout(() => {
          this.sendCommandCallback(cmdBean.cmd);
          i++;
          executeCommands();
        }, delay);
      } else {
        this.sendCommandCallback(cmdBean.cmd);
        i++;
        executeCommands();
      }
    };

    executeCommands();
  }

  getCommand(name, pos, range) {
    if (range <= 0) {
      range = 100;
    }
    const re = this.map(pos, 0, range, 0, 9999);
    let co = "" + re;
    for (let i = co.length; i < 4; i++) {
      co = "0" + co;
    }
    return name + co;
  }

  map(x, in_min, in_max, out_min, out_max) {
    if (x > in_max) {
      x = in_max;
    }
    if (x < in_min) {
      x = in_min;
    }

    const run = in_max - in_min;
    if (run === 0) {
      return -1;
    }
    const rise = out_max - out_min;
    const delta = x - in_min;
    // return (delta * rise) / run + out_min;
    return Math.floor((delta * rise) / run + out_min); // 使用 Math.floor 确保整数
  }
}

export {TCodeFunScript, TCodeFunScriptPlayer};



// WEBPACK FOOTER //
// ./src/tcode/TCodeFunScriptPlayer.js